/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const AgencyFinalReport = {

	getAllowedBasicData (context, onSuccess, onError, options) {
		Api.get(context,
			"/agency-final-report/allowed-basic-data"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getBasicDataByProjectCode (context, projectCode, onSuccess, onError, options) {
		Api.get(context,
			"/agency-final-report/basic-data-by-project-code"
			+ "?projectCode=" + projectCode
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getBasicDataList (context, ids, onSuccess, onError, options) {
		Api.get(context,
			"/agency-final-report/basic-data-list"
			+ "?ids=" + ids
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getConfiguration (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-final-report/configuration"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getCurrentState (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-final-report/current-state"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getFilledData (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-final-report/filled-data"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getReadOnlyData (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-final-report/read-only-data"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getReportManagementStatus (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-final-report/report-management-status"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getSendAndApprovalDates (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-final-report/send-and-approval-dates"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postApprove (context, projectId, agencyFinalReportApprovalDTO, onSuccess, onError, options) {
		Api.post(context,
			"/agency-final-report/approve"
			+ "?projectId=" + projectId
			, agencyFinalReportApprovalDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postCancelCorrections (context, projectId, onSuccess, onError, options) {
		Api.post(context,
			"/agency-final-report/cancel-corrections"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postData (context, projectId, agencyFinalReportFilledDataDTO, onSuccess, onError, options) {
		Api.post(context,
			"/agency-final-report/data"
			+ "?projectId=" + projectId
			, agencyFinalReportFilledDataDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postExportBySearchCriteria (context, contestId, agencyProjectReportExportDTO, onSuccess, onError, options) {
		Api.post(context,
			"/agency-final-report/export-by-search-criteria"
			+ "?contestId=" + contestId
			, agencyProjectReportExportDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postExportCosts (context, costDTO, onSuccess, onError, options) {
		Api.post(context,
			"/agency-final-report/export-costs"
			, costDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postRequestCorrections (context, projectId, cause, onSuccess, onError, options) {
		Api.post(context,
			"/agency-final-report/request-corrections"
			+ "?projectId=" + projectId
			+ "&cause=" + cause
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postSaveAndSubmit (context, projectId, agencyFinalReportFilledDataDTO, onSuccess, onError, options) {
		Api.post(context,
			"/agency-final-report/save-and-submit"
			+ "?projectId=" + projectId
			, agencyFinalReportFilledDataDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putUndoApproval (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/agency-final-report/undo-approval"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
